/* eslint-disable no-shadow,no-param-reassign,no-return-assign,no-sequences */
import Vue from 'vue';


const defaultManagementPanels = {
  information: true,
  children: false,
  obstructions: false,
  actionLog: false,
  comments: false,
  images: false,
  administration: false,
  statistics: false,
};

const defaultDrawingPanels = {
  information: true,
  children: true,
};

const state = {
  management: defaultManagementPanels,
  drawing: defaultDrawingPanels,
};

const mutations = {
  resetPanel(state) {
    Vue.set(state, 'management', defaultManagementPanels);
    Vue.set(state, 'drawing', defaultDrawingPanels);
  },
  setPanel(state, { type, panel, value }) {
    Vue.set(state[type], panel, value);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
